import { Link, Typography } from '@mui/material';
import React from 'react';

interface LocationTypes {
  name: string;
  href: string;
  target?: string;
}

export const Location: React.FC<LocationTypes> = ({ name, href, target }) => {
  const style = {
    color: '#0A3551',
    fontSize: '1.2rem',
    fontWeight: '700',
    textTransform: 'uppercase',
    '@media (orientation: portrait)': {
      fontSize: '1.2rem',
    },
  };

  return (
    <Typography sx={{ ...style }}>({name})</Typography>
    // <Link sx={style} href={href} target={target} underline="none">
    //   ({name})
    // </Link>
  );
};
